/**
 * Elevation Golf Lab — FAQ Nav Active Pill Sync
 * Uses IntersectionObserver to highlight the correct pill as the user scrolls.
 */

(function () {
  const sections = document.querySelectorAll('.faq-cat[data-faq-cat]');
  const pills    = document.querySelectorAll('[data-faq-pill]');

  if (!sections.length || !pills.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        pills.forEach(pill => {
          pill.classList.toggle('is-active', pill.dataset.anchor === id);
        });
      }
    });
  }, {
    rootMargin: '-30% 0px -65% 0px',
    threshold: 0
  });

  sections.forEach(s => observer.observe(s));
})();
